import { OptionalTooltip, Row, Text } from "@/components";
import { Calendar2Icon, ListBullets2Icon } from "@/components/streamline";
import { Button } from "@/components/ui/button";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import { DashboardSchedulePanelView } from "@/types";

export const DashboardSchedulePanelViewToggle = ({
  value,
  onChange,
}: {
  value: DashboardSchedulePanelView;
  onChange: (value: DashboardSchedulePanelView) => void;
}) => {
  const handleChange = (next: DashboardSchedulePanelView) => {
    if (next === value) {
      return;
    }
    mixpanelUtils.trackButtonClick(
      next === DashboardSchedulePanelView.CALENDAR
        ? "Show schedule calendar"
        : "Show schedule tasks",
      MIXPANEL_SCREENS.DASHBOARD,
    );
    onChange(next);
  };

  /* Render */
  const render = () => (
    <Row className="items-center gap-0.5 rounded-none border border-lever-border-light bg-lever-surface-default p-0.5">
      {[
        DashboardSchedulePanelView.CALENDAR,
        DashboardSchedulePanelView.TASKS,
      ].map((option) => {
        const isCalendar = option === DashboardSchedulePanelView.CALENDAR;
        const Icon = isCalendar ? Calendar2Icon : ListBullets2Icon;
        return (
          <OptionalTooltip
            key={option}
            text={
              <Text className="font-lever-suisse text-xs font-normal text-lever-text-body">
                {isCalendar ? "Calendar" : "Tasks"}
              </Text>
            }
            contentClassName="rounded-none border-lever-border-default bg-lever-surface-default"
          >
            <Button
              type="button"
              variant="ghost"
              onClick={() => handleChange(option)}
              className={cn(
                "h-7 w-8 rounded-none p-0 text-lever-icon-label hover:text-lever-icon-label hover:bg-lever-surface-default-on-elevation",
                value === option &&
                  "bg-lever-surface-action text-lever-icon-on-action hover:text-lever-icon-on-action hover:bg-lever-surface-action",
              )}
            >
              <Icon className="h-4 w-4" />
            </Button>
          </OptionalTooltip>
        );
      })}
    </Row>
  );

  return render();
};
